import * as React from 'react';
export const IcStabilization = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.67 4.29a5 5 0 013 3 1 1 0 00.94.67 1 1 0 00.39-.02 1 1 0 00.6-1.27 6.93 6.93 0 00-4.26-4.26 1 1 0 10-.66 1.88h-.01zM3 7.94a1 1 0 001.29-.61 5 5 0 013-3 1 1 0 10-.66-1.88 6.93 6.93 0 00-4.22 4.22A1 1 0 003 7.94zm4.33 11.77a5 5 0 01-3-3A1 1 0 003 16.06a1 1 0 00-.6 1.27 6.93 6.93 0 004.26 4.26c.106.038.217.059.33.06a1 1 0 00.33-1.94h.01zM18 15V9a3 3 0 00-3-3H9a3 3 0 00-3 3v6a3 3 0 003 3h6a3 3 0 003-3zm-6-1a2 2 0 110-4 2 2 0 010 4zm9 2.06a.999.999 0 00-1.28.61 5 5 0 01-3 3 1 1 0 00.28 1.98c.113-.001.224-.022.33-.06a6.93 6.93 0 004.26-4.26 1 1 0 00-.59-1.27z'
      fill='currentColor'
    />
  </svg>
);
